import React, { useState } from "react";
import Modal from "react-modal";

import UserDropdown from "../Dropdowns/UserDropdown";
import { useParams } from "react-router-dom";
Modal.setAppElement("#root");

export default function Navbar() {
  const params = useParams();
  console.log(params);

  const { "*": paramText } = params;
  const summary_detail_path = "summary/summary_detail";
  const is_summary_detail_path = paramText.includes(summary_detail_path);
  console.log(is_summary_detail_path, "paramText");
  return (
    <>
      {/* Navbar */}
      <nav className="bg-[#0471a3] w-full z-10 md:flex-row md:flex-nowrap md:justify-start flex items-center px-4 pt-4 pb-[60px]">
        <div className="w-full mx-auto items-center flex justify-between md:flex-nowrap flex-wrap md:px-10 px-4">
          {/* Brand */}
          <a
            className="text-white text-sm uppercase hidden lg:inline-block font-semibold"
            href="#pablo"
            onClick={(e) => e.preventDefault()}
          >
            {paramText === "create-invoice"
              ? "Create Invoice"
              : paramText === "imprest"
              ? "Imprest List"
              : paramText === "imprest-detail"
              ? "Imprest Detail List"
              : paramText === "estimate-list"
              ? "Estimate Lists"
              : paramText === "create-estimate"
              ? "Create Estimate"
              : paramText === "reports"
              ? "Reports"
              : paramText === "invoice-detail"
              ? "Invoice Detail"
              : paramText === "po-list"
              ? "Po listing"
              : paramText === "invoices"
              ? "Vendor Invoices"
              : paramText === "generate-po"
              ? "Generate Po"
              : paramText === "summary" || is_summary_detail_path
              ? "Summary"
              : "Invoice Lists"}
          </a>
          <ul className="flex-col md:flex-row list-none items-center hidden md:flex">
            <UserDropdown />
          </ul>
        </div>
      </nav>

      {/* End Navbar */}
    </>
  );
}
